import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const ManagementTable = ({ t, management_team }) => {
  const roleLabel = (type) => {
    switch (type) {
      case "ceo":
        return "CEO";
      case "board-of-directors":
        return "Board of Directors";
      case "power-of-attorney":
        return "Power of Attorney";
      case "shareholder":
        return "Shareholder";
      case "other-interest":
        return "Other Interest";
      default:
        // fallback: make it readable
        return (type || "-").replace(/-/g, " ");
    }
  };

  const periodText = (r) => {
    const from = r?.dateFrom ? `From ${r.dateFrom}` : "";
    const to = r?.dateTo ? `Until ${r.dateTo}` : "";
    if (from && to) return `${from}; ${to}`;
    return from || to || "-";
  };

  const managementRows = (management_team || [])
    .filter((p) => (p?.fullName || "").trim().length > 0)
    .map((p) => {
      const roles = Array.isArray(p.roles) ? p.roles : [];

      const roleText =
        roles.length > 0
          ? roles.map((r) => roleLabel(r.type)).join("; ")
          : roleLabel(p.positions); // fallback if roles missing

      const period =
        roles.length > 0
          ? roles
              .map((r) => periodText(r))
              .filter((x) => x && x !== "-")
              .join("; ") || "-"
          : p.roleDateFrom
          ? `From ${p.roleDateFrom}`
          : "-";

      return {
        name: p.fullName,
        role: roleText || "-",
        period,
      };
    });

  return (
    <View style={styles.section}>
      <Text style={styles.alphListItem}>{`3.1 ${t("Management")}`}</Text>

      <View style={styles.table}>
        {/* header row */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Name")}
            </Text>
          </View>

          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Role")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Period")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {managementRows.map((r, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === managementRows.length - 1 ? styles.tableLastRow : {}),
          };

          return (
            <View style={rowStyle} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{r.name ?? "-"}</Text>
              </View>

              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{r.role ?? "-"}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{r.period ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(ManagementTable);
